import React, { Component } from 'react';

class FormContact02 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                name: '',
                email: '',
                phone: '',
                purpose: '',
                message: ''
            },
            loading: false,
            submitted: false
        }
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [name]: value
            }
        }));
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });

        try {
            const { onSubmit } = this.props;
            const success = await onSubmit(this.state.formData);
            
            if (success) {
                this.setState({
                    submitted: true,
                    formData: {
                        name: '',
                        email: '',
                        phone: '',
                        purpose: '',
                        message: ''
                    }
                });
                
                // Reset submitted status after 3 seconds
                setTimeout(() => {
                    this.setState({ submitted: false });
                }, 3000);
            }
        } catch (error) {
            console.error('Form submission error:', error);
        } finally {
            this.setState({ loading: false });
        }
    }

    render() {
        const { formData, loading, submitted } = this.state;

        return (
            <div className="row-contact">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <style>
{`
  .contact-form ::placeholder {
    color: #aaa;
    opacity: 1;
  }
  .contact-form :-ms-input-placeholder {
    color: #aaa;
  }
  .contact-form ::-webkit-input-placeholder {
    color: #aaa;
  }
`}
</style>

                            <div className="themesflat-contact-form style-2 w100 clearfix">
                                {submitted && (
                                    <div className="alert alert-success" style={{
                                        padding: '15px',
                                        marginBottom: '20px',
                                        border: '1px solid #d4edda',
                                        borderRadius: '4px',
                                        backgroundColor: '#d4edda',
                                        color: '#155724'
                                    }}>
                                        Thank you for your message! We will get back to you soon.
                                    </div>
                                )}
                                
                                <form onSubmit={this.handleSubmit} className="contact-form">
                                    <span className="wpcf7-form-control-wrap your-name">
                                        <input 
                                            type="text" 
                                            tabIndex={1} 
                                            id="name" 
                                            name="name" 
                                            value={formData.name}
                                            onChange={this.handleChange}
                                            className="wpcf7-form-control" 
                                            placeholder="Name*" 
                                            required 
                                        />
                                    </span>
                                    
                                    <span className="wpcf7-form-control-wrap your-email">
                                        <input 
                                            type="email" 
                                            tabIndex={3} 
                                            id="email" 
                                            name="email" 
                                            value={formData.email}
                                            onChange={this.handleChange}
                                            className="wpcf7-form-control" 
                                            placeholder="Your Email*" 
                                            required 
                                        />
                                    </span>
                                    
                                    <span className="wpcf7-form-control-wrap your-phone">
                                        <input 
                                            type="text" 
                                            tabIndex={2} 
                                            id="phone" 
                                            name="phone" 
                                            value={formData.phone}
                                            onChange={this.handleChange}
                                            className="wpcf7-form-control" 
                                            placeholder="Phone*" 
                                            required
                                        />
                                    </span>

                                    <span className="wpcf7-form-control-wrap your-purpose">
                                        <select 
                                            name="purpose" 
                                            value={formData.purpose}
                                            onChange={this.handleChange}
                                            className="wpcf7-form-control" 
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px 15px',
                                                border: '1px solid #e5e5e5',
                                                borderRadius: '3px',
                                                fontSize: '14px',
                                                marginBottom: '20px'
                                            }}
                                        >

                 
                                            <option value="">Select Purpose*</option>
                                            <option value="Contractor Enquiry">Contractor Enquiry</option>
                                            <option value="General Inquiry">Construction Enquiry</option>
                                            <option value="Project Consultation">Project Enquiry</option>
                                            
                        
                                        </select>
                                    </span>
                                    
                                    <span className="wpcf7-form-control-wrap your-message">
                                        <textarea 
                                            name="message" 
                                            tabIndex={5} 
                                            cols={40} 
                                            rows={10}
                                            value={formData.message}
                                            onChange={this.handleChange}
                                            className="wpcf7-form-control wpcf7-textarea" 
                                            placeholder="Message*" 
                                            required
                                        />
                                    </span>                                                             
                                    
                                    <span className="wrap-submit">
                                        <input 
                                            type="submit" 
                                            value={loading ? "SENDING..." : "SEND US"} 
                                            className="submit wpcf7-form-control wpcf7-submit" 
                                            id="submit" 
                                            name="submit" 
                                            disabled={loading}
                                        />
                                    </span>                                                            
                                </form>
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={0} data-smobile={35} />
                            <div className="themesflat-map style-2" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="themesflat-spacer clearfix" data-desktop={81} data-mobile={60} data-smobile={60} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FormContact02;